/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toggle-field .mat-slide-toggle-content{font-size:.9rem;font-weight:600}  .toggle-field .mat-slide-toggle-content .info{font-size:80%;font-weight:400}label[_ngcontent-%COMP%]   small[_ngcontent-%COMP%]{line-height:17px;display:block}"];
export { styles as styles };
